import { FC, useMemo, useState } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { message } from 'shared/ui/message'
import { SearchInput } from 'shared/ui/search-input'

import styles from './styles.module.scss'

const STATIC_SORTED_ICONS = Object.values(AllIcons).sort((a, b) =>
  a.localeCompare(b),
)

const IconsPage: FC = () => {
  const [searchQuery, setSearchQuery] = useState('')

  const copyIconText = ({ text }: { text: string }) => {
    navigator.clipboard.writeText(text).then(() => {
      message.copy('Название иконки скопировано')
    })
  }

  const filteredIcons = useMemo(() => {
    const result = !searchQuery
      ? STATIC_SORTED_ICONS
      : STATIC_SORTED_ICONS.filter((icon) =>
          icon.toLowerCase().includes(searchQuery.toLowerCase()),
        )
    return result.sort((a, b) => a.localeCompare(b))
  }, [searchQuery])

  return (
    <section className={clsx(styles.wrapper, 'box')}>
      <div className={styles.searchContainer}>
        <SearchInput
          placeholder="Поиск иконок..."
          onChange={(e) => setSearchQuery(e.currentTarget.value)}
          onReset={() => setSearchQuery('')}
        />
        <div className={styles.searchResults}>
          Найдено иконок: {filteredIcons.length} из {STATIC_SORTED_ICONS.length}
        </div>
      </div>
      <div className={styles.grid}>
        {filteredIcons.map((item) => (
          <div
            className={styles.item}
            onClick={() => {
              copyIconText({ text: item })
            }}
            key={item}
          >
            <AppIcon
              className={styles.iconClass}
              height={40}
              width={40}
              id={item}
            />
            <div className={styles.name}>{item}</div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default IconsPage
